import { render, staticRenderFns } from "./MainTableFour.vue?vue&type=template&id=1f8a1335&scoped=true&"
import script from "./MainTableFour.vue?vue&type=script&lang=js&"
export * from "./MainTableFour.vue?vue&type=script&lang=js&"
import style0 from "./MainTableFour.vue?vue&type=style&index=0&id=1f8a1335&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8a1335",
  null
  
)

export default component.exports